import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyAppBar } from '../../components/layouts/BakeasyAppBar';
import { t } from 'i18next';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  downloadStoreDetails,
  fetchStoreById,
  storesState,
} from '../../redux_store/slices/storesSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import dayjs, { Dayjs } from 'dayjs';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import BakeasyPaper from '../../components/common/BakesasyPaper';
import * as Button from '../../components/buttons/BakeasyButtons';
import { BakeasyImgSelectorView } from '../../components/common/BakeasyImgSelect';
import BakeasyLabelText from '../../components/labels/BakeasyLabelText';
import { AppContext } from '../../context/AppContext';
import i18n from '../../languages/languages';

export const StoreDetails = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = useContext(AppContext);

  const [selectedStatus, setSelectedStatus] = useState<any>('');
  const [selectedCategory, setSelectedCategory] = useState<any>('');
  const [isChainStore, setIsChainStore] = useState<boolean>(true);

  const [parentAddress, setParentAddress] = useState<any>('');
  const [parentCity, setParentCity] = useState<any>('');
  const [parentState, setParentState] = useState<any>('');
  const [parentPostCode, setParentPostCode] = useState<any>('');
  const [parentCountry, setParentCountry] = useState<any>('');
  const [parentEmailId, setParentEmailId] = useState<any>('');
  const [parentWork, setParentWork] = useState<any>('');
  const [description, setDescription] = useState<any>('');

  const [chainStoreName, setChainStoreName] = useState<any>('');
  const [registrationDate, setRegistrationDate] = useState<Dayjs | null>(null);
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [accountingCode, setAccountingCode] = useState<any>('');
  const [storeName, setStoreName] = useState<any>('');
  const [userName, setUserName] = useState<any>('');
  const [legalName, setLegalName] = useState<any>('');
  const [storeAddress, setStoreAddress] = useState<any>('');
  const [storeCity, setStoreCity] = useState<any>('');
  const [storeState, setStoreState] = useState<any>('');
  const [storePostCode, setStorePostCode] = useState<any>('');
  const [storeCountry, setStoreCountry] = useState<any>('');
  const [storeDiscount, setStoreDiscount] = useState<any>('');
  const [storeEmail, setStoreEmail] = useState<any>('');
  const [storeWork, setStoreWork] = useState<any>('');

  const [supplierTax1, setSupplierTax1] = useState<any>('');
  const [supplierTax2, setSupplierTax2] = useState<any>('');
  const [contactOneFirstName, setContactOneFirstName] = useState<any>('');
  const [contactOneLastName, setContactOneLastName] = useState<any>('');
  const [contactOneEmail, setContactOneEmail] = useState<any>('');
  const [contactOneWork, setContactOneWork] = useState<any>('');
  const [contactOneMobile, setContactOneMobile] = useState<any>('');

  const [contactTwoFirstName, setContactTwoFirstName] = useState<any>('');
  const [contactTwoLastName, setContactTwoLastName] = useState<any>('');
  const [contactTwoEmail, setContactTwoEmail] = useState<any>('');
  const [contactTwoWork, setContactTwoWork] = useState<any>('');
  const [contactTwoMobile, setContactTwoMobile] = useState<any>('');

  const [accountingFirstName, setAccountingFirstName] = useState<any>('');
  const [accountingLastName, setAccountingLastName] = useState<any>('');
  const [accountingEmail, setAccountingEmail] = useState<any>('');
  const [accountingWork, setAccountingWork] = useState<any>('');
  const [accountingMobile, setAccountingMobile] = useState<any>('');

  const [billToName, setBillToName] = useState<any>('');
  const [billToCompanyName, setBillToCompanyName] = useState<any>('');
  const [billToAddress, setBillToAddress] = useState<any>('');
  const [billToCity, setBillToCity] = useState<any>('');
  const [billToPostCode, setBillToPostCode] = useState<any>('');
  const [billToCountry, setBillToCountry] = useState<any>('');
  const [billToState, setBillToState] = useState<any>('');

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<any>('');
  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState<any>('');

  const [storeId, setStoreId] = useState<any>('');
  const [selectedBackorder, setSelectedBackorder] = useState<any>('');

  const [selectedShipTo, setSelectedShipTo] = useState<any>('');
  const [shipToName, setShipToName] = useState<any>('');
  const [shipToCompanyName, setShipToCompanyName] = useState<any>('');
  const [shipToAddress, setShipToAddress] = useState<any>('');
  const [shipToCity, setShipToCity] = useState<any>('');
  const [shipToPostCode, setShipToPostCode] = useState<any>('');
  const [shipToCountry, setShipToCountry] = useState<any>('');
  const [shipToState, setShipToState] = useState<any>('');

  const [preferredShippingMethod, setPreferredShippingMethod] =
    useState<any>('');

  const [selectedShippingCharge, setSelectedShippingCharge] = useState<any>('');
  const [selectedShippingCalculation, setSelectedShippingCalculation] =
    useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');

  const [selectedTaxRate1, setSelectedTaxRate1] = useState<any>('');
  const [selectedTaxRate2, setSelectedTaxRate2] = useState<any>('');
  const [selectedBillTo, setSelectedBillTo] = useState<any>('');

  const [selectedStoreLogoFile, setSelectedStoreLogoFile] = useState<
    File | string | null
  >(null);

  let { error, selectedValue } = useAppSelector(storesState);

  useEffect(() => {
    fetchData(location?.state?._id);
  }, []);

  useEffect(() => {
    if (error) {
      navigate(-1);
    }
  }, [error]);

  useEffect(() => {
    if (selectedValue) {
      setData(selectedValue);
    }
  }, [selectedValue]);

  function setData(data: any) {
    setStoreId(data?.storeNumber);
    setAccountingCode(data?.accountingCode);
    setSelectedLanguage(data?.defaultLanguage);
    setSelectedCategory(data?.storeCategory);
    setStoreName(data?.storeName);
    setUserName(data?.userName);
    setLegalName(data?.legalName);
    setStoreAddress(data?.storeAddress?.address);
    setStoreCity(data?.storeAddress?.city);
    setStoreState(data?.storeAddress?.state);
    setStoreCountry(data?.storeAddress?.country);
    setStorePostCode(data?.storeAddress?.zipCode);
    setStoreDiscount(data?.storeDiscount);
    setSelectedBackorder(data?.backOrder ? 'Yes' : 'No');
    setStoreWork(data?.storeWork);
    setStoreEmail(data?.storeEmail);
    setSupplierTax1(data?.supplierTax1);
    setSupplierTax2(data?.supplierTax2);

    setContactOneFirstName(data?.contact1?.firstName);
    setContactOneLastName(data?.contact1?.lastName);
    setContactOneEmail(data?.contact1?.email);
    setContactOneWork(data?.contact1?.work);
    setContactOneMobile(data?.contact1?.mobile);

    setContactTwoFirstName(data?.contact2?.firstName);
    setContactTwoLastName(data?.contact2?.lastName);
    setContactTwoEmail(data?.contact2?.email);
    setContactTwoWork(data?.contact2?.work);
    setContactTwoMobile(data?.contact2?.mobile);

    setAccountingFirstName(data?.contactAccounting?.firstName);
    setAccountingLastName(data?.contactAccounting?.lastName);
    setAccountingEmail(data?.contactAccounting?.email);
    setAccountingWork(data?.contactAccounting?.work);
    setAccountingMobile(data?.contactAccounting?.mobile);

    setIsChainStore(Boolean(data?.chainStore));
    setChainStoreName(data?.chainStoreDetail?.chainStoreName);
    //setBillTo(data?.chainStoreDetail?.billTo);
    setParentAddress(data?.chainStoreDetail?.parentAddress);
    setParentCity(data?.chainStoreDetail?.parentCity);
    setParentState(data?.chainStoreDetail?.parentState);
    setParentPostCode(data?.chainStoreDetail?.parentPostCode);
    setParentCountry(data?.chainStoreDetail?.parentCountry);
    setParentEmailId(data?.chainStoreDetail?.parentEmailId);
    setParentWork(data?.chainStoreDetail?.parentWork);

    setSelectedBillTo(data?.billTo);
    setBillToName(data?.billToInfo?.name);
    setBillToCompanyName(data?.billToInfo?.companyName);
    setBillToAddress(data?.billToInfo?.companyAddress);
    setBillToCity(data?.billToInfo?.city);
    setBillToState(data?.billToInfo?.state);
    setBillToCountry(data?.billToInfo?.country);
    setBillToPostCode(data?.billToInfo?.zipCode);

    setSelectedShipTo(data?.shipTo);
    setShipToName(data?.shipToInfo?.name);
    setShipToCompanyName(data?.shipToInfo?.companyName);
    setShipToAddress(data?.shipToInfo?.companyAddress);
    setShipToCity(data?.shipToInfo?.city);
    setShipToState(data?.shipToInfo?.state);
    setShipToCountry(data?.shipToInfo?.country);
    setShipToPostCode(data?.shipToInfo?.zipCode);

    setSelectedTaxRate1(
      data?.taxes?.rate1 ? { taxName: data?.taxes?.rate1 } : null
    );
    setSelectedTaxRate2(
      data?.taxes?.rate2 ? { taxName: data?.taxes?.rate2 } : null
    );

    setSelectedPaymentMethod(
      data?.payment?.method
        ? { paymentMethod: { ...data?.payment?.method } }
        : null
    );
    setSelectedPaymentTerm(
      data?.payment?.terms
        ? { paymentTerms: { ...data?.payment?.terms } }
        : null
    );

    setSelectedShippingCharge(
      data?.shippingCharges
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );
    setSelectedShippingCalculation(data?.shippingRateType);
    setShippingCharges(data?.shippingRate);
    setPreferredShippingMethod(data?.preferredShippingMethod);

    setSelectedStatus(data?.status);
    setDescription(data?.description);

    setSelectedStoreLogoFile(data?.storeLogo);
  }

  const fetchData = async (_id: any) => {
    try {
      await dispatch(fetchStoreById({ id: _id }));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  };

  function viewStoreDetailsUI() {
    return (
      <Grid>
        <Grid item sx={{ marginBottom: 1 }}>
          <BakeasyAppBar
            title={t('STORE_DETAILS')}
            onBackClick={() => {
              navigate(-1);
            }}
            menus={
              <Grid>
                <div className="tableOptions">
                  <Button.Export
                    onClick={function (
                      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ): void {
                      dispatch(
                        downloadStoreDetails({
                          id: location?.state?._id,
                          downloadType: 'csv',
                        })
                      );
                    }}
                  />
                  <Button.Print
                    onClick={function (
                      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ): void {
                      dispatch(
                        downloadStoreDetails({
                          id: location?.state?._id,
                          downloadType: 'pdf',
                        })
                      );
                    }}
                  />
                </div>
              </Grid>
            }
          />
        </Grid>

        <BakeasyPaper>
          <Grid
            sx={{
              display: 'flex',
              marginLeft: '1',
              justifyContent: 'space-between',
            }}
          >
            <BakeasyHeaderLabel message={'STORE_DETAILS'} />
          </Grid>

          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('DATE_REGISTERED')}
                value={
                  registrationDate
                    ? dayjs(registrationDate).format('MM/DD/YYYY')
                    : dayjs(new Date()).format('MM/DD/YYYY')
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('STORE_ID')} value={storeId} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('ACCOUNTING_CODE')}
                value={accountingCode}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('LANGUAGE')}
                value={selectedLanguage}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('CATEGORY')}
                value={
                  //selectedCategory
                  selectedCategory
                    ? t(
                        `${selectedCategory?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : selectedCategory
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('STORE_NAME')} value={storeName} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('USERNAME')} value={userName} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('LEGAL_NAME')} value={legalName} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_COUNTRY')}
                value={
                  storeCountry
                    ? t(`${storeCountry?.toUpperCase().replace(/\s+/g, '_')}`)
                    : storeCountry
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_STATE_PROVINCE')}
                value={
                  storeState
                    ? t(`${storeState?.toUpperCase().replace(/\s+/g, '_')}`)
                    : storeState
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('STORE_CITY')} value={storeCity} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_ADDRESS')}
                value={storeAddress}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('STORE_POSTAL_CODE')}
                value={storePostCode}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('DISCOUNT_PER')}
                value={storeDiscount}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('BACKORDER')}
                value={selectedBackorder}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('EMAIL_ID')} value={storeEmail} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('WORK')} value={storeWork} />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_TAX1')}
                value={supplierTax1}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText
                label={t('SUPPLIER_TAX2')}
                value={supplierTax2}
              />
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT1')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={contactOneFirstName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={contactOneLastName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={contactOneEmail}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={contactOneWork} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={contactOneMobile}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT2')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={contactTwoFirstName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={contactTwoLastName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={contactTwoEmail}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={contactTwoWork} />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={contactTwoMobile}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('CONTACT_ACCOUNTING')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('FIRST_NAME')}
                  value={accountingFirstName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('LAST_NAME')}
                  value={accountingLastName}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('EMAIL_ID')}
                  value={accountingEmail}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('WORK')} value={accountingWork} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('MOBILE')}
                  value={accountingMobile}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          {isChainStore && (
            <Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
                  <BakeasyHeaderLabel message={t('CHAIN_STORE_PARENT')} />
                </Grid>
                <Grid container ml={2} spacing={2}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('CHAIN_STORE_NAME')}
                      value={chainStoreName}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_COUNTRY')}
                      value={
                        parentCountry
                          ? t(
                              `${parentCountry?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : parentCountry
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('STATE_PROVINCE')}
                      value={
                        parentState
                          ? t(
                              `${parentState?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : parentState
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_CITY')}
                      value={parentCity}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_ADDRESS')}
                      value={parentAddress}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_POSTAL_CODE')}
                      value={parentPostCode}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_EMAIL_ID')}
                      value={parentEmailId}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <BakeasyLabelText
                      label={t('PARENT_WORK')}
                      value={parentWork}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <BakeasyDivider />
            </Grid>
          )}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('BILLING_DETAILS')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('BILL_TO')}
                  value={
                    selectedBillTo
                      ? t(
                          `${selectedBillTo?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : selectedBillTo
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('NAME')} value={billToName} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_NAME')}
                  value={billToCompanyName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COUNTRY')}
                  value={
                    billToCountry
                      ? t(
                          `${billToCountry?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : billToCountry
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('STATE_PROVINCE')}
                  value={
                    billToState
                      ? t(`${billToState?.toUpperCase().replace(/\s+/g, '_')}`)
                      : billToState
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('CITY')} value={billToCity} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_ADDRESS')}
                  value={billToAddress}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('POSTAL_CODE')}
                  value={billToPostCode}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('TAXES')} />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX1')}
                      value={selectedTaxRate1?.taxName ?? selectedTaxRate1}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX2')}
                      value={selectedTaxRate2?.taxName ?? selectedTaxRate2}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX1_RATE')}
                      value={
                        selectedTaxRate1?.taxName
                          ? selectedTaxRate1?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STORE_TAX2_RATE')}
                      value={
                        selectedTaxRate2?.taxName
                          ? selectedTaxRate2?.taxName?.split(' - ', 10).pop()
                          : ''
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <BakeasyHeaderLabel message={t('PAYMENT')} />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} pl={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('METHOD')}
                      value={
                        selectedPaymentMethod?.paymentMethod
                          ? selectedPaymentMethod?.paymentMethod[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('TERMS')}
                      value={
                        selectedPaymentTerm?.paymentTerms
                          ? selectedPaymentTerm?.paymentTerms[i18n.language]
                          : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <BakeasyLabelText
                      label={t('STATUS')}
                      value={
                        selectedStatus
                          ? t(
                              `${selectedStatus?.toUpperCase().replace(/\s+/g, '_')}`
                            )
                          : selectedStatus
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('SHIPPING_DETAILS')} />
            </Grid>

            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIP_TO')}
                  value={
                    //selectedShipTo
                    selectedShipTo
                      ? t(
                          `${selectedShipTo?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : selectedShipTo
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('NAME')} value={shipToName} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_NAME')}
                  value={shipToCompanyName}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COUNTRY')}
                  value={
                    shipToCountry
                      ? t(
                          `${shipToCountry?.toUpperCase().replace(/\s+/g, '_')}`
                        )
                      : shipToCountry
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('STATE_PROVINCE')}
                  value={
                    shipToState
                      ? t(`${shipToState?.toUpperCase().replace(/\s+/g, '_')}`)
                      : shipToState
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText label={t('CITY')} value={shipToCity} />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('COMPANY_ADDRESS')}
                  value={shipToAddress}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('POSTAL_CODE')}
                  value={shipToPostCode}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} ml={2} mt={0}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_CHARGE')}
                  value={selectedShippingCharge}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_CALCULATION')}
                  value={selectedShippingCalculation}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_CHARGES')}
                  value={shippingCharges}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyLabelText
                  label={t('SHIPPING_METHOD')}
                  value={preferredShippingMethod}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyHeaderLabel message={t('OTHER_DETAILS')} />
            </Grid>
            <Grid container spacing={2} ml={2}>
              <Grid item xs={12} sm={12} md={3} lg={6} xl={6}>
                <BakeasyLabelText
                  label={t('DESCRIPTION')}
                  value={description}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                {selectedStoreLogoFile && (
                  <BakeasyImgSelectorView
                    uploadState={'initFromProps'}
                    id="storeLogo"
                    value={selectedStoreLogoFile}
                    label={t('STORE_LOGO')}
                    name="store-logo"
                    headerText={t('ACCEPTED_FORMATS')}
                    footerText={t('PLEASE_UPLOAD')}
                    onClick={() => {
                      myContext.setDialog({
                        open: true,
                        title: t('VIEW_IMAGE'),
                        dialogContent: {
                          pageName: 'ViewImage',
                          imgUrl: selectedStoreLogoFile,
                          title: t('STORE_LOGO'),
                        },
                      });
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </BakeasyPaper>
      </Grid>
    );
  }

  return viewStoreDetailsUI();
};
